var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValesulDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 83,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 268 268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m108.1,59.6l-22,-53.1l-17.6,7.3l-13.5,-13.5l-13.5,13.5l-17.6,-7.3l-22,53.1l53.1,22l53.1,-22zm-71.7,-29.7l18.6,-7.7l18.6,7.7l-18.6,44.9l-18.6,-44.9zm48.3,-20l20,48.3l-44.9,18.6l35.8,-35.8l-25.2,-25.2l14.3,-5.9zm7.3,31.1l-34.3,34.3l19.3,-46.8l-18.6,-7.7l9.5,-3.9l24.1,24.1zm-37,-37l10.9,10.9l-10.9,4.5l-10.9,-4.5l10.9,-10.9zm-49.7,54.2l20,-48.3l14.2,5.9l-25.1,25.2l35.8,35.8l-44.9,-18.6zm12.8,-17.2l24.1,-24.1l9.5,3.9l-18.7,7.7l19.4,46.8l-34.3,-34.3z",
    fill: "#212529"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValesulDiamond);
export default __webpack_public_path__ + "static/media/valesul-diamond.12a3711ed122bb65647c93b6625b9bab.svg";
export { ForwardRef as ReactComponent };